(() => {
  if (window.bonanzaTabsReady) return;
  window.bonanzaTabsReady = true;
  const pending = new WeakSet();

  function refresh(panel, attempt = 0) {
    if (!panel.isConnected || !panel.classList.contains('sr4-active')) return;
    const theme = window.sr4ThemeSP;
    const jq = window.jQuery_T4NT;
    if (!theme?.Carousel || !jq) {
      if (attempt < 100) setTimeout(() => refresh(panel, attempt + 1), 100);
      return;
    }
    if (!panel.dataset.tabInitialized) {
      panel.dataset.tabInitialized = 'true';
      panel.dispatchEvent(new CustomEvent('lazyincluded', { bubbles: true, detail: { isSuccess: true } }));
      panel.querySelectorAll('.flickitysr4').forEach(slider => {
        if (!slider.classList.contains('flickitysr4-enabled')) {
          slider.flickitysr4 = new theme.Carousel(slider);
        }
      });
      theme.reinitProductGridItem?.();
      theme.ProductItem?.resizeObserver?.();
    }
    requestAnimationFrame(() => {
      panel.querySelectorAll('.flickitysr4-enabled').forEach(slider => {
        if (jq.fn.flickitysr4) jq(slider).flickitysr4('resize');
      });
      window.lazySizesT4?.loader?.checkElems?.();
    });
  }

  async function load(panel) {
    if (panel.dataset.tabLoaded === 'true') {
      refresh(panel);
      return;
    }
    if (pending.has(panel)) return;
    pending.add(panel);
    panel.setAttribute('aria-busy', 'true');
    const status = panel.querySelector('[data-tab-status]');
    if (status) status.textContent = panel.dataset.tabLoading;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(panel.dataset.tabSource, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid tab URL');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Tab response ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.getElementById(panel.id);
      if (!content || content.hasAttribute('data-tab-source') || !content.querySelector('.tabs-content-wrap')) {
        throw new Error('Tab content missing');
      }
      content.querySelectorAll('script').forEach(script => script.remove());
      panel.replaceChildren(...Array.from(content.childNodes));
      panel.dataset.tabLoaded = 'true';
      refresh(panel);
    } catch (error) {
      if (status) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-tab-retry', '');
        button.textContent = panel.dataset.tabError;
        status.replaceChildren(button);
      }
      console.warn('Bonanza tab could not load:', error);
    } finally {
      clearTimeout(timeout);
      pending.delete(panel);
      panel.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const retry = event.target.closest('[data-tab-retry]');
    if (retry) {
      const panel = retry.closest('[data-tab-source]');
      if (panel) load(panel);
      return;
    }
    const link = event.target.closest('[data-sr4-tab-ul2] [data-sr4-tab-item]');
    if (!link) return;
    const tabs = link.closest('[data-sr4-tabs2]');
    if (!tabs?.querySelector('[data-tab-source]')) return;
    const id = (link.getAttribute('href') || '').slice(1);
    const panel = document.getElementById(id);
    if (!panel || !tabs.contains(panel)) return;
    event.preventDefault();
    tabs.querySelectorAll('[data-sr4-tab-item]').forEach(item => item.classList.toggle('sr4-active', item === link));
    tabs.querySelectorAll('.sr4-tab-content2').forEach(item => item.classList.toggle('sr4-active', item === panel));
    tabs.setAttribute('data-tab-active', id);
    if (panel.hasAttribute('data-tab-source')) {
      load(panel);
    } else {
      const jq = window.jQuery_T4NT;
      if (jq?.fn.flickitysr4) requestAnimationFrame(() => {
        panel.querySelectorAll('.flickitysr4-enabled').forEach(slider => jq(slider).flickitysr4('resize'));
      });
    }
  });
})();
